import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './InterestBoard.module.css';

function InterestBoard() {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });

  useEffect(() => {
    axios
      .get('/interest-board/groups')
      .then((response) => {
        setGroups(response.data);
      })
      .catch((error) => {
        console.error('Error fetching the groups:', error);
      });
  }, []);

  const handleSelectGroup = (group) => {
    setSelectedGroup(group.name);
    setFormData({
      name: '',
      email: '',
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (group) => async (e) => {
    e.preventDefault();

    try {
      await axios.post('/interest-board/signup', {
        group_name: group.name,
        name: formData.name,
        email: formData.email,
      });

      alert(`Successfully signed up for ${group.name}`);
      setSelectedGroup('');
      setFormData({
        name: '',
        email: '',
      });
    } catch (error) {
      console.error('Error signing up:', error);
      alert('There was an issue submitting your interest. Please try again.');
    }
  };

  return (
    <section className={styles.interestBoard}>
      <div className={styles.hero}>
        <p className={styles.eyebrow}>Community & Fellowship</p>
        <h1 className={styles.heading}>Interest Board</h1>
        <p className={styles.intro}>
          Welcome to our Quihi Bethlehem Lutheran Church Interest Groups page.
          Below you’ll find our active groups as well as several potential groups
          seeking interested members.
        </p>
        <p className={styles.intro}>
          To contact a group or ask questions, enter your name and email, then
          submit your interest. Your information will be forwarded to the
          group’s point of contact, who will reach out to you directly.
        </p>
      </div>

      <div className={styles.legend}>
        <span className={`${styles.legendItem} ${styles.legendEstablished}`}>
          Established Group
        </span>
        <span className={`${styles.legendItem} ${styles.legendPotential}`}>
          Potential Group
        </span>
      </div>

      <div className={styles.groupGrid}>
        {groups.map((group) => {
          const isOpen = selectedGroup === group.name;

          return (
            <article
              key={group.name}
              className={`${styles.groupCard} ${
                group.status === 'established'
                  ? styles.established
                  : styles.potential
              }`}
            >
              <div className={styles.cardTop}>
                <span className={styles.statusBadge}>
                  {group.status === 'established'
                    ? 'Established'
                    : 'Seeking Interest'}
                </span>
                <h2 className={styles.groupTitle}>{group.name}</h2>
              </div>

              <p className={styles.description}>{group.description}</p>

              <div className={styles.contactBox}>
                <span className={styles.contactLabel}>Point of Contact</span>
                <p className={styles.contactText}>{group.contact}</p>
              </div>

              {isOpen ? (
                <form onSubmit={handleSubmit(group)} className={styles.form}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className={styles.input}
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className={styles.input}
                  />

                  <div className={styles.formActions}>
                    <button type="submit" className={styles.primaryButton}>
                      Submit Interest
                    </button>
                    <button
                      type="button"
                      className={styles.secondaryButton}
                      onClick={() => setSelectedGroup('')}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              ) : (
                <button
                  onClick={() => handleSelectGroup(group)}
                  className={styles.primaryButton}
                >
                  Select to Sign Up
                </button>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default InterestBoard;
